﻿export function buildApiRequestErrorText(jqXHR) {
    let errorInfo = undefined;
    try {
        errorInfo = JSON.parse(jqXHR.responseText);
    } catch {
        // kein Problem, nix machen!
    }
    let errorMessage = "";
    if (errorInfo) {
        if (errorInfo.code) {   // ausführliche Fehlermeldung aus dem Service
            errorMessage = `${errorInfo.message} (${errorInfo.code})`;
            if (errorInfo.errorDetails) {
                errorMessage += '<ul class="kaverror">';
                $.each(errorInfo.errorDetails, (i, v) => {
                    errorMessage += `<li class="kaverror">${v.message} (${v.code})</li>`
                });
                errorMessage += "</ul>";
            }
        } else if (errorInfo.title) { // eher knappe Info von der Runtime
            errorMessage = `${errorInfo.title} (${errorInfo.status}) + <br/>${errorInfo.responseText} `;
        }
    } else if (jqXHR.readyState == 0) {
        errorMessage = 'Der API-Server ist nicht erreichbar. Schließen Sie diese Seite und versuchen Sie es später nochmals.';
    } else if (jqXHR.status == 401) {
        errorMessage = 'Sie sind nicht mehr angemeldet. Ihre Anmeldesitzung ist abgelaufen oder ungültig.';
    } else {
        errorMessage = `Fehler ${jqXHR.status}`;
    }
    return errorMessage;
}
// error: string, andernfalls wird jqXHR angenommen
export function showErrorInPage(error, title) {
    let message = undefined;
    if (typeof error === 'string') {
        message = error;
    } else {
        message = buildApiRequestErrorText(error)
    }
    $("#errorMessage").html(message);
    let heading = "Fehler";
    if (typeof title === 'string') {
        heading = title;
    }
    $("#errorHead").text(heading);
    $("#errorBlock").show();
}

export function showRequestErrorInDialog(heading, jqXHR, validationSummary) {
    validationSummary.option("itemTemplate", validationSummaryItemTemplateRequestError);
    let errors = [heading, ""];
    let errorInfo = undefined;
    try {
        errorInfo = JSON.parse(jqXHR.responseText);
    } catch {
    }
    if (errorInfo) {
        if (errorInfo.code) {   // ausführliche Fehlermeldung aus dem Service
            errors[1] = `${errorInfo.message} (${errorInfo.code})`;
            if (errorInfo.errorDetails) {
                $.each(errorInfo.errorDetails, (i, v) => {
                    errors.push(v.message); // Code liefert hier keine zusätzliche Information
                });
            }
        } else if (errorInfo.title) { // eher knappe Info von der Runtime => Programmierfehler!
            errors[1] = `${errorInfo.title} (${errorInfo.status})`;
            errors.push(jqXHR.responseText);    // häßlich, sollte aber nicht oft zu sehen sein
        }
    } else if (jqXHR.readyState == 0) {
        errors[1] = 'Der API-Server ist nicht erreichbar. Schließen Sie diese Seite und versuchen Sie es später nochmals.';
    } else if (jqXHR.status == 401) {
        errors[1] = 'Sie sind nicht mehr angemeldet. Ihre Anmeldesitzung ist abgelaufen oder ungültig.';
    } else {
        errors[1] = `Fehler ${jqXHR.status}`;
    }

    validationSummary.option("items", errors);
}
function validationSummaryItemTemplateRequestError(data, index, element) {
    // index 0: heading
    // index 1: Fehlermeldung
    // index 2ff: ErrorDetails
    element.css("border-style", "none");    // keine Unterstreichung, weil keine Links
    if (index == 0) {
        element.append($('<div class="dx-item-content dx-validationsummary-item servervalidationsummary-item-head" >').text(data));
    } else if (index == 1) {
        element.append($('<div class="dx-item-content dx-validationsummary-item servervalidationsummary-item-error" >').text(data));
    } else {
        element.append($('<div class="dx-item-content dx-validationsummary-item servervalidationsummary-item-errordetail" >').text(data));
    }
}
export function logout(reload) {
    const url = new URL(window.CONFIG.serverApi + "/logout");
    const request = {
        cache: false,
        url: url,
        contentType: 'application/json',
        method: 'POST',
        headers: window.CONFIG.customHeaders,
        success: function (response) {
            console.log("logged out")
            continueLogout(reload);
        },
        error: function (jqXHR) {
            console.error("log out failed");
            continueLogout(reload);
        }
    };
    $.ajax(request);
}
function continueLogout(reload) {
    if (reload) {
        location.reload();
    }
}
